


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY } from './_store';

@Component({
  mixins: [ validationMixin ],
  methods: {
    getFieldError
  },
  validations: {
    form: {
      name: { required }
    }
  }
})
export default class EntitiesManagerForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;

  public form: any = {
    id: null,
    name: null,
    position: 0,
    tax_rate_id: null
  };

  public created() {
    if (this.documentPreview && this.documentPreview.id) {
      this.form = {
        id: this.documentPreview.id,
        name: this.documentPreview.name,
        position: this.documentPreview.position,
        tax_rate_id: this.documentPreview.tax_rate_id
      };
    }
  }

  changeValue(field: string, value: any) {
    this.form[field] = value;

    // @ts-ignore
    const validator = this.$v.form[field];
    if (validator) {
      validator.$touch();
    }
  }

  saveFormData() {
    this.$v.form.$touch()

    if (!this.$v.form.$error) {
      const payload: any = {
        name: this.form.name,
        position: this.form.position,
        tax_rate_id: this.form.tax_rate_id
      };

      if (this.form.id) {
        payload.id = this.form.id;
      }

      this.$store.dispatch(`${STORE_KEY}/saveEntity`, payload)
        .then(() => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();

          this.$emit('form-close');
          (this.$parent as any).close();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
    }
  }
}
